export const isEmptyObj = (o) => {
  return o === undefined || o === null;
};

export const isEmptyStr = (s) => {
  return isEmptyObj(s) || s.length === 0;
};

export const getBrowser = () => {
  let result;
  const userAgent = navigator.userAgent;
  const isOpera = userAgent.indexOf('Opera') > -1;
  if (isOpera) {
    result = 'Opera';
  } else if (userAgent.indexOf('Firefox') > -1) {
    result = 'FF';
  } else if (userAgent.indexOf('Chrome') > -1) {
    result = 'Chrome';
  } else if (userAgent.indexOf('Safari') > -1) {
    result = 'Safari';
  } else if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
    result = 'IE';
  }
  return result;
};

export const getScrollTop = () => {
  let scrollTop = 0;
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body) {
    scrollTop = document.body.scrollTop;
  }
  return scrollTop;
};

// 缩略卡号加*
export const spanAddStar = (str) => {
  if (str.length === 10) {
    return `${str.substr(0, 6)}*${str.substr((str.length - 4), 4)}`;
  }
  return str;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js